var _defs, _path, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 396.82 204.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3855ad;}.cls-2{font-size:156.56px;fill:#8b8b8b;font-family:SitkaHeading-Bold, Sitka;font-weight:700;}.cls-3{letter-spacing:-0.01em;}.cls-4{letter-spacing:-0.08em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.68,207.26c-4.16-2.39-9.53-4.51-14.08-4a48.7,48.7,0,0,0-30,14.3c-11.24,11.33-17.62,25.11-20.32,40.68-.53,3.07-1.78,3.85-4.62,3.75-5.29-.18-10.59,0-15.85,0-.69,3.21-1.24,5.79-1.89,8.83h19.47c-.11,1.43-.1,2.06-.22,2.66-5.47,25.69-10.64,51.45-16.57,77-2.21,9.52-3.69,19.48-7.08,28.8-1.62,4.47-13.6,27.49-19.94,16.41a37.33,37.33,0,0,0-7.16-9.2,9.92,9.92,0,0,0-14,.5c-4.34,4.83-4.91,11.25.15,14.88,28.15,20.21,59-18.45,64.79-42.93,4.47-19,8.25-38.13,12.33-57.2,2.19-10.26,4.39-20.52,6.65-31.09l17.52,0,2.2-8.91H376.08c.45-2.27.64-3.83,1.07-5.33,3-10.71,5.54-21.64,9.47-32,1.89-5,9.54-16.23,15.66-11,3.29,2.82,4.37,7.61,7.64,10.51,4.59,4.08,11.45,3.24,14.68-1.13C428.29,217.8,427.87,210.24,422.68,207.26Z",
    transform: "translate(-102.33 -203.16)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 144.99)"
  }, "P", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 89.06,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 155.79,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 238.18,
    y: 0,
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 291.96,
    y: 0
  }, "it"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e388c0ec8f34070aa03d45346c619a57.svg";
export { ForwardRef as ReactComponent };